/* SplishBox X — interacciones. Cada init comprueba si su elemento existe. */
(function () {
  if (window.__sxLoaded) return; window.__sxLoaded = true;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  function splitWords() {
    $$('.sx-split:not([data-split])').forEach(el => {
      el.dataset.split = '1'; let i = 0;
      const walk = node => [...node.childNodes].forEach(n => {
        if (n.nodeType === 3) {
          const frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(part => {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            const w = document.createElement('span'); w.className = 'w';
            const s = document.createElement('span'); s.style.setProperty('--i', i++); s.textContent = part;
            w.appendChild(s); frag.appendChild(w);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1 && !n.classList.contains('w')) walk(n);
      });
      walk(el);
    });
  }

  function reveal() {
    const els = $$('.sx-in:not(.is-in), .sx-split:not(.is-in), .sx-strike:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(e => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { threshold: .15, rootMargin: '0px 0px -8% 0px' });
    els.forEach(e => io.observe(e));
  }

  function nav() {
    const n = document.querySelector('.sx-nav'); if (!n || n.dataset.ok) return; n.dataset.ok = 1;
    let last = scrollY;
    addEventListener('scroll', () => { const y = scrollY; n.classList.toggle('is-hidden', y > last && y > 400); last = y; }, { passive: true });
  }

  function cursor() {
    if (reduce || matchMedia('(hover: none)').matches || document.querySelector('.sx-cursor')) return;
    const c = document.createElement('div'); c.className = 'sx-cursor'; document.body.appendChild(c);
    let x = innerWidth / 2, y = innerHeight / 2, cx = x, cy = y;
    addEventListener('pointermove', e => { x = e.clientX; y = e.clientY; }, { passive: true });
    (function loop() { cx += (x - cx) * .12; cy += (y - cy) * .12; c.style.transform = `translate(${cx}px,${cy}px)`; requestAnimationFrame(loop); })();
  }

  function cells() {
    $$('.sx-cell').forEach(c => { if (c.dataset.ok) return; c.dataset.ok = 1;
      c.addEventListener('pointermove', e => { const r = c.getBoundingClientRect(); c.style.setProperty('--mx', (e.clientX - r.left) + 'px'); c.style.setProperty('--my', (e.clientY - r.top) + 'px'); }); });
  }

  function magnetic() {
    if (matchMedia('(hover: none)').matches || reduce) return;
    $$('[data-sx-magnet]').forEach(b => { if (b.dataset.ok) return; b.dataset.ok = 1;
      b.addEventListener('pointermove', e => { const r = b.getBoundingClientRect(); b.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * .18}px,${(e.clientY - r.top - r.height / 2) * .25}px)`; });
      b.addEventListener('pointerleave', () => { b.style.transform = ''; }); });
  }

  function dial() {
    $$('[data-sx-dial]').forEach(d => { if (d.dataset.ok) return; d.dataset.ok = 1;
      const max = +d.dataset.max || 480, arc = d.querySelector('[data-arc]'), knob = d.querySelector('[data-knob]'), out = d.querySelector('[data-out]');
      const R = 100, C = 2 * Math.PI * R; let val = 0, prevA = null, auto = true;
      const set = v => { val = Math.max(0, Math.min(max, v)); const turns = val / 360; const a = (val % 360) * Math.PI / 180;
        arc.style.strokeDasharray = `${C * Math.min(1, turns)} ${C}`;
        if (turns > 1) { d.querySelector('[data-arc2]').style.strokeDasharray = `${C * (turns - 1)} ${C}`; } else d.querySelector('[data-arc2]').style.strokeDasharray = `0 ${C}`;
        knob.setAttribute('cx', 120 + R * Math.sin(a)); knob.setAttribute('cy', 120 - R * Math.cos(a)); out.textContent = Math.round(val) + '°'; };
      set(0);
      const angle = e => { const r = d.getBoundingClientRect(); return Math.atan2(e.clientX - (r.left + r.width / 2), -(e.clientY - (r.top + r.height / 2))); };
      d.addEventListener('pointerdown', e => { auto = false; prevA = angle(e); d.setPointerCapture(e.pointerId); });
      d.addEventListener('pointermove', e => { if (prevA === null) return; const a = angle(e); let delta = a - prevA; if (delta > Math.PI) delta -= 2 * Math.PI; if (delta < -Math.PI) delta += 2 * Math.PI; prevA = a; set(val + delta * 180 / Math.PI); });
      const up = () => { prevA = null; }; d.addEventListener('pointerup', up); d.addEventListener('pointercancel', up);
      // demo automática al aparecer
      new IntersectionObserver(([e], o) => { if (!e.isIntersecting || reduce) return; o.disconnect(); const t0 = performance.now();
        (function run(t) { if (!auto) return; const k = Math.min(1, (t - t0) / 2600); set(max * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(run); })(t0); }, { threshold: .5 }).observe(d);
    });
  }

  function droplets() {
    $$('[data-sx-droplets]').forEach(b => { if (b.childElementCount || reduce) return;
      for (let i = 0; i < 26; i++) { const d = document.createElement('i'); const s = 5 + Math.random() * 16;
        Object.assign(d.style, { width: s + 'px', height: s * 1.15 + 'px', left: Math.random() * 100 + '%', top: (-20 + Math.random() * 80) + '%', animationDuration: (6 + Math.random() * 10) + 's', animationDelay: (-Math.random() * 10) + 's', opacity: (.4 + Math.random() * .6).toFixed(2) });
        b.appendChild(d); } });
  }

  function switches() {
    $$('[data-sx-switch]').forEach(s => { if (s.dataset.ok) return; s.dataset.ok = 1;
      const set = st => { s.dataset.state = st; $$('[data-to]', s).forEach(b => b.setAttribute('aria-pressed', b.dataset.to === st)); };
      $$('[data-to]', s).forEach(b => b.addEventListener('click', () => set(b.dataset.to)));
      new IntersectionObserver(([e], o) => { if (e.isIntersecting) { o.disconnect(); setTimeout(() => set('after'), 1400); } }, { threshold: .5 }).observe(s);
    });
  }

  function money(c, f) { return (f || '${{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, (c / 100).toFixed(2)); }

  function product() {
    $$('[data-sx-product]').forEach(root => { if (root.dataset.ok) return; root.dataset.ok = 1;
      const variants = JSON.parse((root.querySelector('[data-sx-variants]') || {}).textContent || '[]');
      const fmt = root.dataset.money, idIn = root.querySelector('input[name="id"]');
      const priceEl = root.querySelector('[data-sx-price]'), cmpEl = root.querySelector('[data-sx-compare]');
      const add = root.querySelector('[data-sx-add]'), addLbl = root.dataset.add, soldLbl = root.dataset.sold;
      const colorOf = v => { const s = (v || '').toLowerCase(); return /black|negro|noir|dark/.test(s) ? 'black' : /white|blanco|blanc/.test(s) ? 'white' : null; };
      const update = () => {
        const chosen = $$('.sx-opt', root).map(f => (f.querySelector('input:checked') || {}).value);
        $$('[data-sx-optval]', root).forEach((el, i) => { if (chosen[i]) el.textContent = chosen[i]; });
        chosen.forEach(c => { const col = colorOf(c); if (col) document.dispatchEvent(new CustomEvent('sx:color', { detail: col })); });
        const v = variants.find(x => x.options.every((o, i) => o === chosen[i]));
        const lbl = add && add.querySelector('[data-l]');
        if (!v) { if (add) { add.disabled = true; lbl.textContent = soldLbl; } return; }
        idIn.value = v.id; priceEl.textContent = money(v.price, fmt);
        if (cmpEl) cmpEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price, fmt) : '';
        if (add) { add.disabled = !v.available; lbl.textContent = v.available ? addLbl : soldLbl; }
        $$('[data-sx-sticky-price]').forEach(e => e.textContent = money(v.price, fmt));
        const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
        packLabel();
      };
      let packLabel = () => {};
      $$('.sx-opt input', root).forEach(i => i.addEventListener('change', update));
      setTimeout(() => { const c = $$('.sx-opt input:checked', root).map(i => colorOf(i.value)).find(Boolean); if (c) document.dispatchEvent(new CustomEvent('sx:color', { detail: c })); }, 600);
      document.addEventListener('sx:color', e => { // botones del visor 3D → seleccionan la variante
        $$('.sx-opt input', root).forEach(i => { if (colorOf(i.value) === e.detail && !i.checked) { i.checked = true; update(); } }); });
      const q = root.querySelector('.sx-qty input');
      $$('[data-sx-q]', root).forEach(b => b.addEventListener('click', () => { q.value = Math.max(1, (+q.value || 1) + +b.dataset.sxQ); }));
      // packs: fijan la cantidad y ponen el total en el botón
      const packs = $$('[data-sx-packs] input', root);
      packLabel = () => { const p = packs.find(i => i.checked); if (!p) return; q.value = p.value;
        if (add && !add.disabled) add.querySelector('[data-l]').textContent = `${addLbl} · ${p.dataset.total}`; };
      packs.forEach(i => i.addEventListener('change', packLabel)); packLabel();
      const sticky = document.querySelector('[data-sx-sticky]');
      if (sticky && add) { new IntersectionObserver(([e]) => sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(add);
        sticky.querySelector('button').addEventListener('click', () => add.click()); }
      const lb = document.querySelector('[data-sx-lightbox]');
      if (lb) { const img = lb.querySelector('img');
        $$('[data-sx-zoom]', root).forEach(b => b.addEventListener('click', () => { img.src = b.dataset.sxZoom; lb.classList.add('is-on'); }));
        lb.addEventListener('click', () => lb.classList.remove('is-on')); }
    });
  }

  function gallery() {
    $$('[data-sx-gal]').forEach(g => { if (g.dataset.ok) return; g.dataset.ok = 1;
      const track = g.querySelector('[data-sx-gal-track]'), slides = $$('.sx-gal__slide', g), thumbs = $$('[data-sx-gal-go]', g), num = g.querySelector('[data-sx-gal-i]');
      let cur = 0; const t0 = performance.now();
      const go = i => { i = (i + slides.length) % slides.length; track.scrollTo({ left: slides[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); };
      const mark = () => { const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); if (i === cur) return; cur = i;
        if (num) num.textContent = i + 1; thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i)); };
      track.addEventListener('scroll', () => requestAnimationFrame(mark), { passive: true });
      thumbs.forEach(t => t.addEventListener('click', () => go(+t.dataset.sxGalGo)));
      $$('[data-sx-gal-step]', g).forEach(b => b.addEventListener('click', () => go(cur + +b.dataset.sxGalStep)));
      // al elegir Blanco/Negro, salta a la primera foto de ese color (no al cargar la página)
      document.addEventListener('sx:color', e => { if (performance.now() - t0 < 1500) return;
        const i = slides.findIndex(s => (s.dataset.alt || '').toLowerCase().includes(e.detail)); if (i >= 0 && i !== cur) go(i); });
      const lb = document.querySelector('[data-sx-lightbox]');
      if (lb) { const img = lb.querySelector('img');
        $$('[data-sx-zoom]', g).forEach(b => b.addEventListener('click', () => { img.src = b.dataset.sxZoom; lb.classList.add('is-on'); })); }
    });
  }

  let timerOn = false;
  function timers() {
    if (timerOn) return; timerOn = true;
    const pad = n => String(n).padStart(2, '0');
    // busca los relojes en cada segundo: el carrito vuelve a pintar su pie al cambiar cantidades
    const tick = () => { const now = new Date(), end = new Date(now); end.setHours(24, 0, 0, 0); // medianoche local del cliente
      const s = Math.max(0, Math.floor((end - now) / 1000));
      $$('[data-sx-timer]').forEach(t => { t.querySelector('[data-h]').textContent = pad(Math.floor(s / 3600)); t.querySelector('[data-m]').textContent = pad(Math.floor(s / 60) % 60); t.querySelector('[data-s]').textContent = pad(s % 60); }); };
    tick(); setInterval(tick, 1000);
  }

  document.addEventListener('sx:color', e => { window.__sxColor = e.detail; });
  const init = () => { splitWords(); reveal(); nav(); cursor(); cells(); magnetic(); dial(); droplets(); switches(); product(); gallery(); timers(); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);
})();
